var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo62(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 650",
    style: {
      enableBackground: "new 0 0 650 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#E7F6FD;}\n\t.st3{fill:#272428;}\n\t.st4{display:inline;fill:#E81F64;}\n\t.st5{display:inline;fill:#AF1E4F;}\n\t.st6{display:inline;fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{display:inline;fill:#E7F6FD;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st9{display:inline;fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st10{fill:#E8F6FD;stroke:#000000;stroke-width:9;stroke-miterlimit:10;}\n\t.st11{fill:#E7F6FD;stroke:#000000;stroke-miterlimit:10;}\n\t.st12{stroke:#000000;stroke-miterlimit:10;}\n\t.st13{fill:#E81F64;}\n\t.st14{fill:#AF1E4F;}\n\t.st15{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M385.9,301.5c-10.9-4.3-18-14.9-18-26.6v-126h-85.7v126c0,11.8-7.2,22.3-18.1,26.7 c-61.8,24.5-105.4,85-104.8,155.7c0.8,91.2,74.5,164.3,165.8,164.3c91.6,0,165.8-74.2,165.8-165.8 C490.8,385.6,447.3,325.7,385.9,301.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M325,625.3c-45.1,0-87.6-17.4-119.5-49c-31.9-31.6-49.7-73.9-50.1-119c-0.3-35,9.9-68.6,29.6-97.4 c19.2-28,46.1-49.4,77.6-61.9c9.6-3.8,15.7-12.9,15.7-23.1V145.1h93.3v129.8c0,10.3,6.1,19.3,15.6,23.1 c31.3,12.4,58,33.6,77.2,61.3c19.7,28.4,30.1,61.8,30.1,96.5c0,45.3-17.6,87.9-49.7,119.9C412.9,607.6,370.3,625.3,325,625.3z  M286,152.7v122.2c0,13.4-8.1,25.3-20.5,30.2c-61.8,24.5-103,85.6-102.4,152.1c0.8,88.5,73.4,160.5,162,160.5 c89.3,0,162-72.7,162-162c0-66.9-40.2-126.1-102.5-150.7c-12.4-4.9-20.4-16.7-20.4-30.2V152.7H286z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370,131.7h-90c-9.5,0-17.2,7.7-17.2,17.2l0,0c0,9.5,7.7,17.2,17.2,17.2h90c9.5,0,17.2-7.7,17.2-17.2l0,0 C387.1,139.4,379.4,131.7,370,131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M370,169.8h-90c-11.6,0-21-9.4-21-21c0-11.6,9.4-21,21-21h90c11.6,0,21,9.4,21,21 C390.9,160.4,381.5,169.8,370,169.8z M280,135.5c-7.4,0-13.4,6-13.4,13.4c0,7.4,6,13.4,13.4,13.4h90c7.4,0,13.4-6,13.4-13.4 c0-7.4-6-13.4-13.4-13.4H280z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M470.7,399.2c-87.5-37-110.3,15.3-184,44.8c-47.2,18.9-85.8-16-107.7-44.2c-2.1,5.4-3.9,11-5.3,16.7 c-3.2,12.5-4.9,25.6-4.9,39.1c0,86.3,69.9,156.2,156.2,156.2s156.2-69.9,156.2-156.2C481.2,435.7,477.5,416.7,470.7,399.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325,424.9v186.9c0,0,0,0,0,0c86.3,0,156.2-69.9,156.2-156.2c0-19.9-3.7-38.9-10.5-56.4 C400.3,369.4,371.8,397.4,325,424.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2312 -0.9729 0.9729 0.2312 -283.7471 640.9051)",
    className: "st6",
    cx: 263.6,
    cy: 500,
    rx: 21.1,
    ry: 21.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 307.5,
    cy: 530.3,
    r: 9.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M347.6,471.1c0,4.3-3.5,7.8-7.8,7.8c-4.3,0-7.8-3.5-7.8-7.8c0-4.3,3.5-7.8,7.8-7.8 C344.1,463.3,347.6,466.8,347.6,471.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -151.1838 376.8136)",
    className: "st6",
    cx: 379.3,
    cy: 370.9,
    rx: 14.3,
    ry: 14.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M308,375.5c0,5.4-4.3,9.7-9.7,9.7s-9.7-4.3-9.7-9.7c0-5.4,4.3-9.7,9.7-9.7S308,370.1,308,375.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 393.3,
    cy: 507,
    r: 14.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M470.7,399.2c-87.5-37-110.3,15.3-184,44.8c-47.2,18.9-85.8-16-107.7-44.2c-2.1,5.4-3.9,11-5.3,16.7 c-3.2,12.5-4.9,25.6-4.9,39.1c0,86.3,69.9,156.2,156.2,156.2s156.2-69.9,156.2-156.2C481.2,435.7,477.5,416.7,470.7,399.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2312 -0.9729 0.9729 0.2312 243.1056 402.9966)",
    className: "st8",
    cx: 376.5,
    cy: 47.7,
    rx: 21.1,
    ry: 21.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 17.7461 247.8685)",
    className: "st8",
    cx: 308.1,
    cy: 102.5,
    rx: 14.3,
    ry: 14.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 332.3,
    cy: 229,
    r: 14.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M332.8,60.9c0,4.3-3.5,7.8-7.8,7.8c-4.3,0-7.8-3.5-7.8-7.8c0-4.3,3.5-7.8,7.8-7.8 C329.3,53.1,332.8,56.6,332.8,60.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 325,
    cy: 325,
    r: 325
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M544.5,497.5L377.7,217.9c-7.8-13.1-11.9-28-11.9-43.2V50.5h-88.9v124.2c0,15.2-4.1,30.1-11.9,43.2 L98.1,497.5c-14.1,23.7,2.9,53.7,30.5,53.7H514C541.6,551.2,558.6,521.2,544.5,497.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M367.4,27.1h-93.4c-9.8,0-17.8,8-17.8,17.8l0,0c0,9.8,8,17.8,17.8,17.8h93.4c9.8,0,17.8-8,17.8-17.8l0,0 C385.2,35.1,377.2,27.1,367.4,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M367.4,66.7h-93.4c-12,0-21.8-9.8-21.8-21.8c0-12,9.8-21.8,21.8-21.8h93.4c12,0,21.8,9.8,21.8,21.8 C389.2,57,379.4,66.7,367.4,66.7z M273.9,31.1c-7.6,0-13.9,6.2-13.9,13.9c0,7.6,6.2,13.9,13.9,13.9h93.4 c7.6,0,13.9-6.2,13.9-13.9c0-7.6-6.2-13.9-13.9-13.9H273.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M512.3,540c18.9,0,30.6-20.6,20.9-36.8L417,308.5c-36.6-4.6-44.4,7.7-90.8,34.2 c-50.4,28.8-109-22.2-109-22.2l-109,182.7c-9.7,16.2,2,36.8,20.9,36.8H512.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M417,308.5c-36.6-4.6-44.4,7.7-90.8,34.2c-1.6,0.9-3.2,1.8-4.9,2.5V540h191c18.9,0,30.6-20.6,20.9-36.8 L417,308.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 303.5,
    cy: 265.9,
    r: 18.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 354,
    cy: 389.2,
    r: 11.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M423.9,450.6c0,9.6-7.8,17.4-17.4,17.4s-17.4-7.8-17.4-17.4c0-9.6,7.8-17.4,17.4-17.4 S423.9,441,423.9,450.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1593 -0.9872 0.9872 0.1593 -277.742 609.7478)",
    className: "st15",
    cx: 219.2,
    cy: 468,
    rx: 25.8,
    ry: 25.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M295,433.2c0,5-4,9-9,9c-5,0-9-4-9-9c0-5,4-9,9-9C290.9,424.2,295,428.2,295,433.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M352.2,305.6c0,4.2-3.4,7.6-7.6,7.6c-4.2,0-7.6-3.4-7.6-7.6c0-4.2,3.4-7.6,7.6-7.6 C348.8,298,352.2,301.4,352.2,305.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 325.4,
    cy: 165.4,
    r: 11.3
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-657.5,499.4l-120.1-237.6c-5.8-12-8.9-25.1-8.9-38.5V18.8h-47.3h-47.3v204.5c0,13.3-3,26.5-8.9,38.5 l-120.1,237.6c-9,18.5,4.4,40,25,40h151.3h151.3C-662,539.4-648.5,517.9-657.5,499.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-682.5,543.6h-302.7c-11.1,0-21.2-5.6-27.1-15c-5.9-9.4-6.5-21-1.6-31l120.2-237.7 c5.5-11.3,8.4-23.9,8.4-36.6V14.6h102.9v208.7c0,12.6,2.9,25.3,8.5,36.6l120.1,237.6c4.9,10,4.3,21.6-1.6,31 C-661.3,537.9-671.4,543.6-682.5,543.6z M-876.9,23v200.3c0,13.9-3.2,27.8-9.3,40.3l-120.2,237.7c-3.6,7.3-3.1,15.8,1.2,22.8 c4.3,6.9,11.8,11.1,20,11.1h302.7c8.2,0,15.7-4.1,20-11.1c4.3-6.9,4.8-15.5,1.2-22.8l-120.1-237.6c-6.1-12.5-9.3-26.5-9.3-40.4 V23H-876.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-668.8,505l-77.1-152.6h-175.8L-998.9,505c-2.3,4.8-2,10.1,0.8,14.6c2.8,4.5,7.5,7.1,12.9,7.1h302.7 c5.4,0,10-2.6,12.9-7.1C-666.8,515.1-666.5,509.8-668.8,505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-784.2-0.1h-99.3c-10.5,0-18.9,8.5-18.9,18.9l0,0c0,10.5,8.5,18.9,18.9,18.9h99.3 c10.5,0,18.9-8.5,18.9-18.9l0,0C-765.3,8.3-773.7-0.1-784.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-784.2,41.9h-99.3c-12.8,0-23.1-10.4-23.1-23.1c0-12.8,10.4-23.1,23.1-23.1h99.3 c12.8,0,23.1,10.4,23.1,23.1C-761.1,31.6-771.4,41.9-784.2,41.9z M-883.5,4.1c-8.1,0-14.7,6.6-14.7,14.7 c0,8.1,6.6,14.7,14.7,14.7h99.3c8.1,0,14.7-6.6,14.7-14.7c0-8.1-6.6-14.7-14.7-14.7H-883.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-745.9,352.4h-87.9v174.3h151.3c5.4,0,10-2.6,12.9-7.1c2.8-4.5,3.1-9.8,0.8-14.6L-745.9,352.4z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: -860.7,
    cy: 308.4,
    r: 20.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: -801.3,
    cy: 381.5,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-746.5,404.8c0,6.2-5,11.3-11.3,11.3s-11.3-5-11.3-11.3c0-6.2,5-11.3,11.3-11.3S-746.5,398.6-746.5,404.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1593 -0.9872 0.9872 0.1593 -1139.5117 -520.2906)",
    className: "st6",
    cx: -875.3,
    cy: 408.9,
    rx: 27.4,
    ry: 27.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-807,418.5c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C-811.2,408.9-807,413.2-807,418.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-813.3,325.6c0,3.5-2.9,6.4-6.4,6.4s-6.4-2.9-6.4-6.4c0-3.5,2.9-6.4,6.4-6.4S-813.3,322.1-813.3,325.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-316.6,518.1l-112-221.5c-5.5-11.2-8.3-23.4-8.3-35.9V70H-481H-525v190.7c0,12.4-2.8,24.7-8.3,35.9 l-112,221.5c-8.4,17.2,4.1,37.3,23.3,37.3H-481h141.1C-320.7,555.3-308.2,535.3-316.6,518.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-339.9,559.2h-282.2c-10.3,0-19.8-5.2-25.3-14c-5.5-8.8-6-19.6-1.5-28.9l112-221.6 c5.1-10.5,7.9-22.3,7.9-34.1V66.1h96v194.6c0,11.8,2.7,23.6,7.9,34.1l112,221.5c4.6,9.3,4,20.1-1.5,28.9 C-320.1,554-329.5,559.2-339.9,559.2z M-521.1,73.9v186.8c0,12.9-3,25.9-8.7,37.6l-112,221.6c-3.3,6.8-2.9,14.8,1.1,21.2 c4,6.5,11,10.3,18.6,10.3h282.2c7.6,0,14.6-3.9,18.6-10.3c4-6.5,4.5-14.4,1.1-21.3l-112-221.5c-5.7-11.7-8.7-24.7-8.7-37.6V73.9 H-521.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-434.7,52.4h-92.5c-9.7,0-17.6,7.9-17.6,17.6l0,0c0,9.7,7.9,17.6,17.6,17.6h92.5c9.7,0,17.6-7.9,17.6-17.6 l0,0C-417.1,60.3-425,52.4-434.7,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-434.7,91.6h-92.5c-11.9,0-21.6-9.7-21.6-21.6c0-11.9,9.7-21.6,21.6-21.6h92.5c11.9,0,21.6,9.7,21.6,21.6 C-413.1,81.9-422.8,91.6-434.7,91.6z M-527.3,56.3c-7.6,0-13.7,6.2-13.7,13.7c0,7.6,6.2,13.7,13.7,13.7h92.5 c7.6,0,13.7-6.2,13.7-13.7c0-7.6-6.2-13.7-13.7-13.7H-527.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-322.8,526.2l-66.3-131l-8.7-17.4c-26-9.9-41.9-5.8-57.8,2.7c-13.3,7.2-26.6,17.5-45.8,25.2 c-27.2,10.9-49.5-8.8-62.5-25.2c-0.2-0.2-0.4-0.5-0.6-0.7c-0.3,0.9-0.6,1.7-0.9,2.6l-72.7,143.8c-2.2,4.6-1.9,9.7,0.8,14 c2.7,4.3,7.2,6.8,12.3,6.8h289c5.1,0,9.6-2.5,12.3-6.8C-320.8,535.8-320.6,530.7-322.8,526.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-322.8,526.2l-66.3-131l-8.7-17.4c-26-9.9-41.9-5.8-57.8,2.7c-8.1,4.4-16.3,9.9-25.7,15.3V547h145.3 c5.1,0,9.6-2.5,12.3-6.8C-320.8,535.8-320.6,530.7-322.8,526.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: -488.2,
    cy: 289.2,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: -450.7,
    cy: 424.5,
    r: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-408.6,477.1c0,7.1-5.7,12.8-12.8,12.8c-7.1,0-12.8-5.7-12.8-12.8s5.7-12.8,12.8-12.8 C-414.3,464.3-408.6,470-408.6,477.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1593 -0.9872 0.9872 0.1593 -922.2542 -164.1404)",
    className: "st6",
    cx: -557.5,
    cy: 459.4,
    rx: 25.5,
    ry: 25.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-498,464.3c0,4.9-4,8.9-8.9,8.9c-4.9,0-8.9-4-8.9-8.9c0-4.9,4-8.9,8.9-8.9C-501.9,455.4-498,459.4-498,464.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-461.9,356c0,3.3-2.7,5.9-5.9,5.9c-3.3,0-5.9-2.7-5.9-5.9c0-3.3,2.7-5.9,5.9-5.9 C-464.5,350.1-461.9,352.8-461.9,356z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: -467.8,
    cy: 187.9,
    r: 11.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo62);
export default __webpack_public_path__ + "static/media/Logo 6.2.89011e8f.svg";
export { ForwardRef as ReactComponent };